import { NoteInput } from 'sr-types/lib/note/v1/graphql';
import { Reference } from 'sr-types/lib/production/v1/graphql';
import { Note } from 'sr-types/lib/search/v1/graphql';
import { deriveNoteTitleFromContent } from '../../common/notes/utils';

export const getNoteInputForProduction = (note: Note, productionReference: Reference): NoteInput => {
    const { id, content, labels, reference, title } = note;
    const noteId = id || reference?.id;

    return {
        identity: {
            id: noteId
        },
        entityReference: productionReference,
        content,
        title: title || deriveNoteTitleFromContent(content),
        labels
    };
};
